<template>
  <div>
    <footer>
      <div>
        <p class="footer">
        	Artfiber s.n.c. © 2023<br/>
          P.IVA & C.F. 00503870263
        	<a href="https://www.iubenda.com/privacy-policy/8044434"
             class="iubenda-white iubenda-embed"
             title="Privacy Policy"
             target="_blank"
          >
        	- Privacy Policy
        	</a>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'footer-view'
}
</script>
